import { NeoModel, ModelBase } from "@singularsystems/neo-core";

@NeoModel
export default class OrganisationInstrumentTypeLookup extends ModelBase {

    public organisationInstrumentTypeId: number = 0;

    public organisationId: number = 0;

    public staticInstrumentTypeId: number = 0;

    public organisationName: string = "";

    public staticInstrumentTypeName: string = "";
}